"use client";
import React, { useEffect, useMemo, useState } from "react";
import { getYouMayLikeProducts } from "@/src/models/products";
import ProductList from "../../components/ProductInTable/ProductList";
import { useProductDetailsContext } from "@/src/provider";
import stl from "./productRecommended.module.scss";
import { useTranslation } from "@/src/i18n/client";
interface IProps {}

const YouMayLike: React.FC<IProps> = (props) => {
    const { t } = useTranslation("common");
    const [productDetail] = useProductDetailsContext((state) => [
        state.productDetail,
    ]);
    const [youMayLikeList, setYouMayLikeList] = useState<any[]>([]);
    useEffect(() => {
        //获取热销产品
        getYouMayLikeProducts(productDetail.products_id!).then((data) => {
            setYouMayLikeList(data);
        });
    }, [productDetail.products_id]);

    const rList = useMemo(
        () =>
            youMayLikeList.map((item: any) => {
                return {
                    ...item,
                    product_price: { ...item },
                };
            }),
        [youMayLikeList],
    );
    return (
        rList.length > 0 && (
            <React.Fragment>
                <p className={stl["you-may-like"]}>
                    {t("common:nav.YouMayLike")}
                </p>
                <ProductList
                    data={rList ? rList.slice(0, 4) : []}
                    type={"hot"}
                />
            </React.Fragment>
        )
    );
};

export default YouMayLike;
